import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=93576826&scoped=true"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=93576826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93576826",
  null
  
)

export default component.exports